import React, { FC, useRef } from 'react';

import { useContainerWidth } from '../useContainerWidth';
import { useMeasureContainerWidth } from '../useMeasureContainerWidth';

import { ContainerWidthContext } from './context';

export const ContainerWidthProvider: FC = ({ children }) => {
  const ref = useRef<HTMLDivElement>(null);
  const parentContextWidth = useContainerWidth();
  const measuredWidth = useMeasureContainerWidth(ref);
  const width = measuredWidth ?? parentContextWidth;

  return (
    <>
      <ContainerWidthContext.Provider value={width}>{children}</ContainerWidthContext.Provider>
      <div ref={ref} />
    </>
  );
};
